export const dropDownLight = {
  errorColor: 'error',
  errorBg: 'error',
  dropdownSpacing: 8,
  borderRadius: 20,
  placeholderStyle: {
    color: 'primary/text',
  },
  dropDownHeaderStyle: {
    bg: 'grey/light/background',
  },
  /* variants: {
      positive: {
          placeholderStyle: {
              color: "grey/light",
          },
          dropDownHeaderStyle: {
              bg: "grey/dark/background",
              border: "unset",

          },
      },
  }, */
};

export const dropDownHeaderLight = {
  border: '1px solid',
  borderColor: 'transparent',
  borderRadius: 20,
  color: 'primary/text',
  fontFamily: 'regular',
  fontSize: 's',
  lineHeight: 'm',
  iconStyle: {
    color: 'primary',
    width: 20,
    height: 20,
  },
  height: 44,
  padding: '8px 16px',
  alignItems: 'center',
  justifyContent: 'space-between',
  cursor: 'pointer',
  display: 'flex',
  width: '100%',
  states: {
    '> span': {
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      textWrap: 'nowrap',
    },
  },
};

export const dropDownOptionsContainerLight = {
  backgroundColor: 'grey/light/background',
  borderRadius: 's',
  py: '0px',
  color: 'primary/text',
  overflow: 'hidden',
  boxShadow: 'rgba(0, 0, 0, 0.4) 0px 0px 16px 0px',
  states: {
    '&:-webkit-scrollbar-track': {
      background: 'red',
    },
    '& button': {
      backgroundColor: 'transparent',
      textAlign: 'left',
    },
    '& button:not(:last-of-type)': {
      borderBottom: '1px solid',
      borderColor: 'transparent',
      backgroundColor: 'transparent',
    },
  },
};

export const optionLight = {
  color: 'primary/text',
  px: 'xs',
  py: 'xxs',
  width: '100%',
  justifyContent: 'center',
  border: 0,
  outline: 'none',
  optionTextVariant: 'P4',
  selectedStyle: {
    bg: 'grey/medium',
  },
  iconStyle: {
    name: 'down',
    color: 'primary/text',
  },
  checkboxStyle: {
    marginRight: 'xs',
  },
  selectedIconStyle: {
    name: 'checkSelected',
  },
  states: {
    '& p': {
      whiteSpace: 'unset !important', // TODO: remove this when the DS is updated
      color: 'primary/text',
    },
  },
};
